<template>
    <modal :modal-id="modalId"
                     :title="modalTitle"
                     :preloader="preloader"
                     @submit="submit"
                     @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="mb-0"
                  :class="{'loading-opacity': preloader}"
                  ref="form" :data-url='selectedUrl ? `container/${inputs.id}` : `container`'>
                <div class="form-group row align-items-center">
                    <label for="inputs_name" class="col-sm-4 mb-0">
                        {{ $t('container_name') }}
                    </label>
                    <app-input id="inputs_name"
                               class="col-sm-8"
                               type="text"
                               v-model="inputs.name"
                               :placeholder="$t('container_name_hint')"
                               :required="true"/>

                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_container_config" class="col-sm-4 mb-0">
                        {{ $t('container_config') }}
                    </label>
                    <app-input id="inputs_container_config"
                               class="col-sm-8"
                               type="text"
                               v-model="containerConfig"
                               :minLength = "64"
                               :maxLength = "64"
                               :placeholder="$t('container_config_hint')"
                               :required="true"/>
                               <div v-if="errorMessage"><small class="text-danger validation-error">{{ errorMessage }}</small></div>

                </div>
                <div v-html="$t('container_config_hint2')"/>
                
                <!--
                <div class="form-group row align-items-center">
                    <label for="inputs_phone" class="col-sm-3 mb-0">
                        {{ $t('contact_number') }}
                    </label>
                    <app-input id="inputs_phone"
                               class="col-sm-9"
                               type="tel-input"
                               v-model="phone"
                               :placeholder="$t('type_contact_number')"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_status" class="col-sm-3 mb-0">
                        {{ $t('status') }}
                    </label>
                    <app-input id="inputs_status"
                               class="col-sm-9"
                               type="select"
                               :required="true"
                               v-model="inputs.status"
                               :list="statusLists"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_age" class="col-sm-3 mb-0">
                        {{ $t('age') }}
                    </label>
                    <app-input id="inputs_age"
                               class="col-sm-9"
                               type="number"
                               :max-number="100"
                               v-model="inputs.age"
                               :placeholder="$t('type_age')"/>
                </div>
                <div class="form-group row align-items-center mb-0">
                    <label class="col-sm-3 mb-0">
                        {{ $t('gender') }}
                    </label>
                    <app-input class="col-sm-9"
                               type="radio"
                               v-model="inputs.gender"
                               :list="genderLists"/>
                </div>-->
            </form>
        </template>
    </modal>
</template>

<script>
    import { assertLiteral } from '@babel/types';
import {FormMixin} from '../../../../core/mixins/form/FormMixin.js';
    import {ModalMixin} from "../../../Mixins/ModalMixin.js";
    import {ref} from 'vue';

    export default {
        name: "AddModal",
        mixins: [FormMixin, ModalMixin],
        props: {
            tableId: String
        },
        data() {
            return {
                preloader: false,
                inputs: {
                    gender: 'male',
                },
                phone: '',
                containerConfig: '',
                statusLists: [
                    {id: '', value: "Choose One",},
                    {id: 'active', value: "Active",},
                    {id: 'inactive', value: "Inactive",},
                    {id: 'invited', value: "Invite",},
                ],
                genderLists: [
                    {id: 'male', value: "Male"},
                    {id: 'female', value: "Female"},
                    {id: 'other', value: "Other"},
                ],
                modalId: 'container-add-edit-Modal',
                modalTitle: this.$t('add'),
            }
        },
        created() {
            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.preloader = true;
            }
        },
        setup() {
            
            const containerConfig = ref('');
            const errorMessage = ref('');

            function validateInput() {
                //alert(inputValue.value.length);
                console.log(this);
                if (containerConfig.value.length !== 64) {
                    errorMessage.value = 'Input must be exactly 64 characters.';
                } else {
                    errorMessage.value = '';
                }
            }

            return {
            containerConfig,
            errorMessage,
            validateInput,
            };
        },
        methods: {
            submit() {
                //this.inputs.phone = this.phone;
                this.inputs.container_config = this.containerConfig;
                this.save(this.inputs);
            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
                this.validationError = '';
                this.closeModal();
            },

            afterSuccessFromGetEditData(response) {
                if (response.data.phone) this.phone = response.data.phone;
                if (response.data.container_config) this.containerConfig = response.data.container_config;
                this.inputs = response.data;
                this.preloader = false;
            },
            
            hideModal() {
                $('#' + this.modalId).modal('hide');
            },

            closeModal(value) {
                this.hideModal();
                this.$emit("close-modal", value);
            },
        },
    }
</script>
